import React, {SelectHTMLAttributes} from 'react';
import {Label, SelectStyled} from './styled';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
    label?: string,
    error?: string,
    options: Array<any>,
    placeholder?: string
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
    }),
);

const Select: React.FC<Props> = ({
                                     id,
                                     name,
                                     label,
                                     options,
                                     disabled,
                                     required,
                                     value,
                                     error,
                                     placeholder = 'Selecione uma Opção',
                                     onChange,
                                     onBlur,
                                     style
                                 }) => {
    const classes = useStyles();

    return (
        <>
            {label && <Label htmlFor={id}>{label}</Label>}
            <SelectStyled style={style} id={id} disabled={disabled} name={name} onChange={onChange} onBlur={onBlur} value={value}
                          required={required}>
                <option value="">{placeholder}</option>
                {options.map((option) => (
                    <option key={option.id} value={option.id}>{option.description}</option>
                ))}
            </SelectStyled>
            {error &&
                <div className={classes.root}>
                    <Alert severity="error">{error}</Alert>
                </div>
            }
        </>
    )
}

export default Select;